import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React, { FC, useState } from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";

interface PostOrderMoreButtonProps {
  canUpdate: boolean;
  canCancel: boolean;
  setModal: (arg: "edit" | "cancel") => void;
}

export const PostOrderMoreButton: FC<PostOrderMoreButtonProps> = ({
  canCancel = true,
  canUpdate = true,
  setModal = (arg: string) => {},
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {(canCancel || canUpdate) && (
        <>
          <IconButton onClick={handleClick}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {canUpdate && (
              <MenuItem onClick={() => setModal("edit")}>
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                {t("edit")}
              </MenuItem>
            )}
            {canCancel && (
              <MenuItem onClick={() => setModal("cancel")}>
                <ListItemIcon>
                  <CancelOutlinedIcon fontSize="small" />
                </ListItemIcon>
                {t("cancel")}
              </MenuItem>
            )}
          </Menu>
        </>
      )}
    </>
  );
};
